import {
  Calendar,
  convertTask,
  Task,
  TasksQueryParams,
  TasksResponse,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useTasks(
  params: TasksQueryParams,
  calendar: Calendar | undefined,
  enabled = true
) {
  const { server } = useServer()

  return useQuery<Task[]>({
    queryKey: keys.list(calendar, params),
    queryFn: fetchTasks,
    enabled: enabled && !!params.storeId,
  })

  async function fetchTasks(): Promise<Task[]> {
    if (!params.storeId) {
      throw new Error('Store ID is required')
    }
    if (!params.fromDate) {
      throw new Error('From date is required')
    }
    if (!params.toDate) {
      throw new Error('To date is required')
    }
    const queryParams = new URLSearchParams()

    queryParams.append('from_date', params.fromDate)
    queryParams.append('to_date', params.toDate)

    let url: string

    if (calendar === 'store') {
      url = `v2/tasks/custom/store/${params.storeId}`
    } else {
      if (params.userId === undefined) {
        throw new Error('User ID is required')
      }
      url = `v2/tasks/custom/user/${params.storeId}/${params.userId}`
    }

    const queryString = queryParams.toString()
    if (queryString) {
      url += `?${queryString}`
    }

    const response = await server.get<TasksResponse.Task[]>(url)
    return response.map(convertTask)
  }
}
